import { useEffect, useRef } from 'react'

type LeaveGuard = () => boolean | Promise<boolean>

/**
 * 메뉴 이동(상단 탭·왼쪽 메뉴) 전에 지금 화면에 떠나도 되는지 묻는다 — 저장 안 한 행 보호(LOGISPRD-14801).
 * `BrowserRouter` 라 react-router 의 `useBlocker`(data router 전용)를 못 쓴다. 이동을 일으키는 쪽이 `confirmLeave` 를 직접 부른다.
 * 본문 화면은 한 번에 하나라 가드도 하나다.
 */
let current: LeaveGuard | null = null

export const confirmLeave = async (): Promise<boolean> => (current ? current() : true)

/** 화면이 떠 있는 동안 가드를 건다. `guard` 는 매 렌더 새 함수여도 된다 — 마지막 것을 부른다. */
export const useLeaveGuard = (guard: LeaveGuard) => {
  const ref = useRef(guard)
  ref.current = guard
  useEffect(() => {
    const registered: LeaveGuard = () => ref.current()
    current = registered
    return () => {
      if (current === registered) current = null
    }
  }, [])
}
